/**
 * E3 · Botones del bloque de oferta y de la fila de añadidos del carrito.
 * "cambiar": sustituye la línea por otra (la misma con plan de suscripción, o el Ritual / el pack).
 * "anadir": añade una variante (con plan si lo hay). Después pide a Horizon que repinte el carrito.
 */
const repintar = () =>
  document.dispatchEvent(new CustomEvent('cart:update', { bubbles: true, detail: { resource: {}, sourceId: 'la-carrito', data: {} } }));

document.addEventListener('click', async (e) => {
  const b = e.target.closest('[data-la-accion]');
  if (!b || b.disabled) return;
  e.preventDefault();
  b.disabled = true;
  const { laAccion, linea, plan, variante, regla, camino } = b.dataset;
  try {
    if (laAccion === 'cambiar' && linea) {
      const carrito = await (await fetch('/cart.js')).json();
      const item = carrito.items.find((i) => i.key === linea);
      if (!item) return;
      await fetch('/cart/change.js', {
        method: 'POST',
        headers: { 'Content-Type': 'application/json' },
        body: JSON.stringify({ id: linea, quantity: 0 }),
      });
      await fetch('/cart/add.js', {
        method: 'POST',
        headers: { 'Content-Type': 'application/json' },
        body: JSON.stringify({
          items: [{ id: Number(variante) || item.variant_id, quantity: item.quantity, ...(plan ? { selling_plan: plan } : {}) }],
        }),
      });
    } else if (laAccion === 'anadir' && variante) {
      const linea = { id: Number(variante), quantity: 1 };
      if (plan) linea.selling_plan = plan;
      await fetch('/cart/add.js', {
        method: 'POST',
        headers: { 'Content-Type': 'application/json' },
        body: JSON.stringify({ items: [linea] }),
      });
    }
    // Medición (E3): bloque de carrito pulsado. Klaviyo / píxel pueden escuchar este evento.
    document.dispatchEvent(new CustomEvent('la:carrito-oferta', { detail: { regla, camino, accion: laAccion } }));
    window.dataLayer?.push({ event: 'la_carrito_oferta', regla, camino, accion: laAccion });
  } finally {
    b.disabled = false;
    repintar();
  }
});

// Medición: bloque visto (una vez por regla y camino en cada visita).
const vistos = new Set();
const medirVisto = () => {
  document.querySelectorAll('.la-carrito-oferta').forEach((el) => {
    const k = `${el.dataset.regla}-${el.dataset.camino}`;
    if (vistos.has(k) || !el.offsetParent) return;
    vistos.add(k);
    document.dispatchEvent(new CustomEvent('la:carrito-oferta-visto', { detail: { ...el.dataset } }));
    window.dataLayer?.push({ event: 'la_carrito_oferta_visto', regla: el.dataset.regla, camino: el.dataset.camino });
  });
};
new MutationObserver(medirVisto).observe(document.documentElement, { subtree: true, childList: true, attributes: true, attributeFilter: ['open', 'class'] });
